<template>
  <div class="addSeckill">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>添加/编辑预售</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" label-width="80px">
      <el-form-item label="产品">
        <el-button type="primary" @click="dialogVisible = true">选择产品</el-button>
      </el-form-item>
      <el-form-item label="" class="chanpin" v-show="formList.prodType">
        <table
          border="1"
          style="border-radius: 5px; border: 1px solid #dcdfe6; color: #606266"
          cellSpacing="0px"
        >
          <tr>
            <td style="border: 0px; text-align: center; padding-left: 10px">产品名称</td>
            <td style="border: 0px; text-align: center; width: 250px">原价</td>
            <td style="border: 0px; text-align: center; width: 250px">预售价</td>
            <td style="border: 0px; text-align: center">操作</td>
          </tr>
          <tr style="height: 60px">
            <td style="border: 0px; text-align: center; padding-left: 10px">
              <span>{{ tableData[0].name }}</span>
            </td>
            <td style="border: 0px; text-align: center">
              <el-input
                style="width: 200px"
                @change="onChange"
                v-model="formList.oldPrice"
                placeholder="请输入原价"
              ></el-input>
            </td>
            <td style="border: 0px; text-align: center">
              <el-input
                style="width: 200px"
                @change="onChange"
                v-model="formList.price"
                placeholder="请输入预售价"
              ></el-input>
            </td>
            <td style="border: 0px; width: 100px; text-align: center">
              <el-button type="primary" @click="onquxiao">取消</el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item label="预售名称">
        <el-input v-model="formList.presaleName" placeholder="请输入预售名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="游戏ID">
        <el-input
          v-model="formList.gameId"
          placeholder="购票成功后是否参与游戏预售  0 为不参与"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="预售图片">
        <send-image
          :images="formList.imgUrl"
          v-if="Number(id) == 0 || (Number(id) > 0 && formList.presaleName !== '')"
          @addImageStr="addImageStr"
        ></send-image>
      </el-form-item>
      <el-form-item
        ><span style="color: red">请选择图片,推荐尺寸375*188px</span></el-form-item
      >
      <el-form-item label="预售开始时间">
        <el-date-picker
          v-model="formList.beginTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择预售开始时间"
        >
        </el-date-picker>
        -
        <el-date-picker
          v-model="formList.endTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择预售结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="" style="height: 50px; margin: 0"
        ><span style="color: red">预售的销售时间</span></el-form-item
      >
      <el-form-item label="预售标签" style="margin-top: 0px">
        <el-input v-model="formList.label" placeholder="请输入预售标签"></el-input>
      </el-form-item>
      <el-form-item label="分享标题" style="margin-top: 0px">
        <el-input v-model="formList.shareTitle" placeholder="请输入分享标题"></el-input>
      </el-form-item>
      <el-form-item label="产品使用时间">
        <el-date-picker
          v-model="formList.useBeginTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择预售开始时间"
        >
        </el-date-picker>
        -
        <el-date-picker
          v-model="formList.useEndTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择预售结束时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="" style="height: 50px; margin: 0"
        ><span style="color: red"
          >客户购买该产品后的预约使用时间只有在这个时间段使用</span
        ></el-form-item
      >
      <el-form-item label="限购数量" style="margin-top: 0px">
        <el-input
          @input="onInput"
          v-model="formList.quotaCount"
          placeholder="请输入限购数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="" style="height: 50px; margin: 0"
        ><span style="color: red"
          >一个客户可购买的数量:0表示不限制,1表示可以购买一次,2表示可以购买两次,以此类推</span
        ></el-form-item
      >
      <el-form-item label="预售数量" style="margin-top: 0px">
        <el-input
          @input="onInput"
          v-model="formList.stock"
          placeholder="请输入预售数量数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="" style="height: 50px; margin: 0"
        ><span style="color: red">参加预售的总数量,该预售销售多少份</span></el-form-item
      >
      <!-- <el-form-item label=" 提前预定天数" style="margin-top: 0px">
        <el-input
          v-model.number="formList.advanceDay"
          placeholder="请输入提前预定天数"
        ></el-input>
      </el-form-item>
      <el-form-item label="" style="height: 50px; margin: 0"
        ><span style="color: red">0表示不限制</span></el-form-item
      > -->

      <el-form-item
        label="是否退订"
        style="margin-top: 0px; display: flex; align-items: center"
      >
        <el-radio v-model="radio" label="1">是</el-radio>
        <el-radio v-model="radio" label="0">否</el-radio>
      </el-form-item>
      <el-form-item
        label="是否改期"
        style="margin-top: 0px; display: flex; align-items: center"
      >
        <el-radio v-model="formList.changeInfo" :label="1">是</el-radio>
        <el-radio v-model="formList.changeInfo" :label="0">否</el-radio>
      </el-form-item>
      <el-form-item
        label="是否显示"
        style="margin-top: 0px; display: flex; align-items: center"
      >
        <el-radio v-model="formList.isShow" :label="1">是</el-radio>
        <el-radio v-model="formList.isShow" :label="0">否</el-radio>
      </el-form-item>
      <el-form-item label="是否仅限新用户购买">
        <el-radio v-model="formList.isNew" :label="1">是</el-radio>
        <el-radio v-model="formList.isNew" :label="0">否</el-radio>
      </el-form-item>
      <el-form-item label="预售说明" class="col">
        <!-- <quill-editor
            class="richEdit"
            v-model="formList.remark"
            :options="quillOption"
          >
          </quill-editor> -->
        <VueUeditorWrap v-model="formList.remark" :config="myConfig"></VueUeditorWrap>
      </el-form-item>
      <el-form-item class="col" style="margin-top: 130px">
        <div class="btn">
          <el-button type="primary" @click="onSave">保存</el-button>
          <el-button type="primary" @click="$router.go(-1)">返回</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-dialog
      :close-on-click-modal="false"
      title="选择产品"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <select-products @addData="onAddData" v-if="dialogVisible"></select-products>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Quill } from "vue-quill-editor";
import quillConfig from "../../../../quill-config";
import selectProducts from "./selectPresaleProducts";
import { getPresaleListAdd, getPresaleListDetails } from "../../../api/seckillInfo";
import { roomDetails } from "../../../api/room";
import { ticketDetails } from "../../../api/ticket";
import { travelSpecDetails } from "../../../api/travelSpecs";
import { sendFile } from "../../../api/sendFile";
import SendImage from "../../../components/sendImage.vue";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "addSeckill",
  components: {
    selectProducts,
    SendImage,
    VueUeditorWrap,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    addid: {
      type: [Number, String],
    },
    type: {
      type: [Number, String],
    },
  },
  data() {
    return {
      myConfig: {
        toolbars: [
          [
            "simpleupload", //单图上传
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "selectall",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "customstyle",
            "paragraph",
            "fontfamily",
            "fontsize",
            "|",
            "directionalityltr",
            "directionalityrtl",
            "indent",
            "|",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "touppercase",
            "tolowercase",
            "|",
            "imagenone",
            "imageleft",
            "imageright",
            "imagecenter",
            "|",
            "emotion",
            "map",
            "insertcode",
            "background",
            "|",
            "horizontal",
            "date",
            "time",
            "spechars",
            "|",
            "inserttable",
            "deletetable",
            "insertparagraphbeforetable",
            "insertrow",
            "deleterow",
            "insertcol",
            "deletecol",
            "mergecells",
            "mergeright",
            "mergedown",
            "|",
            "print",
            "preview",
          ],
        ],
        autoHeightEnabled: false, // 编辑器不自动被内容撑高
        initialFrameHeight: 600, // 初始容器高度
        initialFrameWidth: "50%", // 初始容器宽度
        serverUrl: "/config",
        UEDITOR_HOME_URL: "/static/UEditor/",
        maximumWords: "100000000",
      },
      quillOption: quillConfig,
      dialogVisible: false,
      tableData: [
        {
          name: "",
          oldPrice: "",
          price: "",
        },
      ],
      radio: "1",
      formList: {
        shareTitle: "",
        presaleName: "",
        beginTime: "",
        endTime: "",
        quotaCount: null,
        useBeginTime: "",
        useEndTime: "",
        label: "",
        stock: null,
        prodType: null,
        prodId: null,
        oldPrice: null,
        price: null,
        imgUrl: "",
        // gameId: "",
        remark: "",
        changeInfo: 1,
        isShow: 1,
        isNew:0
        // advanceDay: 0,
      },
      isBack: 1,
    };
  },
  watch: {
    radio: function () {
      this.isBack = Number(this.radio);
    },
  },
  mounted() {
    quillConfig.register(Quill);
    quillConfig.initButton();
  },
  created() {
    if (Number(this.id != 0)) {
      this.getgroupBuyDetail();
    }
    if (Number(this.id) == 0 && Number(this.type) == 1 && Number(this.addid) !== 0) {
      this.getroomDetails();
    } else if (
      Number(this.id) == 0 &&
      Number(this.type) == 2 &&
      Number(this.addid) !== 0
    ) {
      this.getticketDetails();
    } else if (
      Number(this.id) == 0 &&
      Number(this.type) == 3 &&
      Number(this.addid) !== 0
    ) {
      this.gettravelSpecDetails();
    }
  },
  methods: {
    addImageStr(image) {
      this.formList.imgUrl = image;
    },
    onSendImg() {
      this.$refs.fileRefs.click();
    },
    onClose() {
      this.formList.imgUrl = "";
    },
    async onFileChange(event) {
      // 根据这个 <input> 获取文件的 HTML5 js 对象
      var files = event.target.files;
      if (files && files.length > 0) {
        // 获取目前上传的文件
        var file = files[0];
        var formData = new FormData();
        formData.append("file", file);
        const { data } = await sendFile(formData);
        console.log();
        this.formList.imgUrl = data.data[0].src;
      }
    },
    async getroomDetails() {
      const { data } = await roomDetails({
        roomId: Number(this.addid),
      });
      this.formList.prodType = Number(this.type);
      this.tableData[0].name = data.data[0].roomName;
      this.formList.prodId = Number(this.addid);
    },
    async getticketDetails() {
      const { data } = await ticketDetails({
        ticketId: Number(this.addid),
      });
      this.formList.prodType = Number(this.type);
      this.tableData[0].name = data.data[0].ticketName;
      this.formList.prodId = Number(this.addid);
    },
    async gettravelSpecDetails() {
      const { data } = await travelSpecDetails({
        specsId: Number(this.addid),
      });
      this.formList.prodType = Number(this.type);
      this.tableData[0].name = data.data[0].specName;
      this.formList.prodId = Number(this.addid);
    },
    async getgroupBuyDetail() {
      const { data } = await getPresaleListDetails({
        presaleId: Number(this.id),
      });
      this.formList.presaleName = data.data[0].presaleName;
      this.formList.imgUrl = data.data[0].imgUrl;
      this.formList.beginTime = data.data[0].beginTime;
      this.formList.endTime = data.data[0].endTime;
      this.formList.useBeginTime = data.data[0].useBeginTime;
      this.formList.useEndTime = data.data[0].useEndTime;
      this.formList.label = data.data[0].label;
      this.formList.stock = data.data[0].stock;
      this.formList.quotaCount = data.data[0].quotaCount;
      this.formList.prodType = data.data[0].prodType;
      this.formList.prodId = data.data[0].prodId;
      this.formList.oldPrice = data.data[0].oldPrice;
      this.formList.price = data.data[0].price;
      this.formList.remark = data.data[0].remark;
      // this.formList.gameId = data.data[0].gameId;
      this.formList.changeInfo = data.data[0].changeInfo;
      this.formList.isShow = data.data[0].isShow;
      this.formList.isNew = data.data[0].isNew || 0;
      // this.formList.advanceDay = data.data[0].advanceDay;
      this.formList.shareTitle = data.data[0].shareTitle;
      this.isBack = data.data[0].isBack;
      this.radio = data.data[0].isBack + "";
      this.tableData[0].name = data.data[0].prodName;
      console.log(data, "------------");
    },
    async onSave() {
      for (const key in this.formList) {
        if (this.formList[key] === null || this.formList[key] === "") {
          return this.$message.error("请把数据填写完整");
        }
      }
      const { data } = await getPresaleListAdd({
        ...this.formList,
        isBack: this.isBack,
        presaleId: Number(this.id),
      });
      if (data.code == 0) {
        this.$message.success(data.msg);
        this.$router.go(-1);
      } else {
        this.$message.error(data.msg);
      }
    },
    onInput(value) {
      var reg = /^[0-9]*[1-9][0-9]*$/;
      var reg2 = /^-[0-9]*[1-9][0-9]*$/;
      if (!reg.test(value) && !reg2.test(value)) {
        return this.$message({
          type: "error",
          message: "请输入整数!",
        });
      }
    },
    onChange(value) {
      var reg = /^(0\.?\d{0,5}|[1-9]\d*\.?\d{0,5})$/;
      if (!reg.test(value)) {
        return this.$message({
          type: "error",
          message: "请输入非负数!",
        });
      }
    },
    onAddData(obj, type) {
      this.formList.prodType = type;
      this.tableData[0].name = obj.name;
      this.formList.prodId = obj.id;
      this.dialogVisible = false;
    },
    onquxiao() {
      this.formList.prodType = null;
      this.tableData[0].name = "";
      this.formList.prodId = null;
    },
  },
};
</script>
<style lang="less" scoped>
.addSeckill {
  .el-breadcrumb {
    height: 35px;
    border-bottom: 1px solid rgb(192, 191, 191);
  }
  /deep/.el-form-item {
    margin-top: 50px;
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: 120px !important;
      display: flex;
      .img {
        position: relative;
        height: 100px;
        width: 100px;
        margin: 20px 20px;
        img {
          height: 100px;
          width: 100px;
          border: 1px solid #c0ccda;
        }
        div {
          position: absolute;
          top: 0;
          right: 2px;
          height: 10px;
          width: 10px;
          z-index: 100;
        }
      }
      .addImg {
        display: inline-block;
        width: 100px;
        height: 100px;
        border: 1px dashed #c0ccda;
        text-align: center;
        line-height: 100px;
        cursor: pointer;
        margin-top: 20px;
        i {
          width: 50px;
          height: 50px;
          font-size: 20px;
          color: #c0ccda;
        }
      }
      .el-input {
        width: 600px;
      }
      .el-date-editor {
        width: 292px !important;
      }
    }
  }
  /deep/ .chanpin {
    .el-form-item__content {
      .el-table {
        .el-table__body-wrapper {
          tbody {
            td {
              .el-input {
                width: 100% !important;
              }
            }
          }
        }
      }
    }
  }
}
.richEdit {
  width: 600px;
  height: 600px;
  .ql-container {
    height: 510px;
  }
}
</style>
